import { render, staticRenderFns } from "./actionSheetBox.vue?vue&type=template&id=63b8c226&scoped=true"
import script from "./actionSheetBox.vue?vue&type=script&lang=js"
export * from "./actionSheetBox.vue?vue&type=script&lang=js"
import style0 from "./actionSheetBox.vue?vue&type=style&index=0&id=63b8c226&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63b8c226",
  null
  
)

export default component.exports